<template>
  <a-card>
    <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
      <a-form-item label="项目名称" name="projectName">
        <a-input v-model:value="searchForm.projectName" placeholder="请输入" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="onSearch">查询</a-button>
        <a-button @click="onReset">重置</a-button>
      </a-form-item>
    </a-form>
    <div class="table-toolbar">
      <a-button type="primary" @click="onAdd">
        <template #icon>
          <plus-outlined />
        </template>
        新增
      </a-button>
      <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)">
        <a-button danger>批量删除</a-button>
      </a-popconfirm>
    </div>
    <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
      <template #message>
        已选择 {{ selectedRowKeys.length }} 项
        <a @click="onClearSelected" class="ml-20 float-right">清空</a>
      </template>
    </a-alert>
    <a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
      <template #peType="{ record }">
        <span>{{ record.peType && record.peType == 1 ? '待评估' : '已评估' }}</span>
      </template>
      <template #picture="{ record }">
        <div style="position: relative; width:35px; height:35px; margin: 3px 3px; overflow: hidden;">
          <img-upload style="position: absolute; top:-35px; left:-35px" v-model:value="record.technologyProject.picture"
            :showList="true" disabled />
        </div>
      </template>
      <template #projectName="{ record }">
        <a @click="onDetail(record)">{{ record.technologyProject.projectName }}</a>
      </template>
    </a-table>
  </a-card>
  <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
  <DetailModal ref="detailModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
</template>

<script>
import DetailModal from './components/DetailModal';
import UserModal from './components/UserModal';
import { tableListMixin } from "@/mixins";
import { projectEvaluationInfo } from "@/api/achievementsService";

const columns = [
  // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
  { title: "评估状态", dataIndex: "peType", key: "peType", slots: { customRender: "peType" } },
  { title: "项目图片", dataIndex: "picture", key: "picture", slots: { customRender: "picture" } },
  { title: "项目名称", dataIndex: "technologyProject.projectName", key: "technologyProject.projectName", slots: { customRender: "projectName" } },
  { title: "项目总投资(万元)", dataIndex: "technologyProject.investment", key: "technologyProject.investment" },
  { title: "项目负责人", dataIndex: "technologyProject.projectLinkman", key: "technologyProject.projectLinkman" },
  { title: "评估人/机构名称", dataIndex: "name", key: "name" },
  { title: "联系电话", dataIndex: "phoneNumber", key: "phoneNumber" },
];
export default {
  name: "index",
  mixins: [tableListMixin],
  components: {
    DetailModal, UserModal,
  },
  data() {
    return {
      columns,
      queryParam: {},
      listUrl: projectEvaluationInfo.pageList,
      listKeyField: "id",
      editUrl: projectEvaluationInfo.saveOrUpdate,
      deleteUrl: projectEvaluationInfo.remove,
    }
  },
  methods: {
    onAdd() {
      this.onShowModal('userModal');
    },
    onEdit(record) {
      this.getAction({
        url: projectEvaluationInfo.detail,
        params: { id: record.id }
      }).then(res => {
        this.onShowModal('userModal', res);
      })
    },
    onDetail(record) {
      this.getAction({
        url: projectEvaluationInfo.detail,
        params: { id: record.id }
      }).then(res => {
        this.onShowModal('detailModal', res);
      })
    },
  }
}
</script>

<style scoped></style>
